import { preview } from "./preview";
import { actionBrowse } from "./browse";
import { user } from "../../user";
import { settings } from "../../common/setting";
import { URLS } from "fire-wind-water";
import $ from "jquery";
import { Subject, forkJoin } from "rxjs";
import { scmsService } from "../../services/site";

async function onInit(cn) {
  const $initSubject = new Subject<any>();
  const $endSubject = new Subject<any>();
  const hz = {
    skUserInit() {
      const m = (window as any).$sk.template.get();
      user.globalUserId = m.user.globalUserId;
      $initSubject.next();
      $initSubject.complete();
      cn();
    },
    skUserEnd() {
      const m = (window as any).$sk.template.get();
      user.session = m.user.session;
      user.memberId = m.user.memberId;
      user.openId = m.user.openId;
      // alert(JSON.stringify(m));
      $cz.event("initUserEnd");
      $endSubject.next();
      $endSubject.complete();

      if (
        window.location.href.indexOf("articleinfo") > -1 &&
        $("#login_url").text()
      ) {
        if ($("#login_url").text().length > 0 && !m.user.session) {
          //没有sess 并且配置了登录
          $(".article-content").remove();
          window.location.href = URLS.updateSearchParam(
            "backUrl",
            encodeURIComponent(window.location.href),
            $("#login_url").text()
          );
        }
      }
    },
  };
  forkJoin($initSubject, $endSubject).subscribe(() => {
    //文章、文件详情页需要加载完详情之后再调用浏览
    /* 菜单加载完后调用浏览接口
    const pageList = ["articleinfo", "fileinfo", "filelist", "articlelist", "videolist", "meetinglist", "blanklist"];
    let isLoad = true;
    //链接转小写
    let href = window.location.href;
    href = href.toLowerCase();
    pageList.forEach((d) => {
      if (href.indexOf(d) > -1) {
        isLoad = false;
      }
    });
    if (isLoad) {
      actionBrowse();
    }*/
  });

  (window as any).$sk.template.module(hz);
  const param = {
    tenantId: settings.tenantId,
    siteId: settings.siteId,
    category: settings.category,
  };
  scmsService.getWecaht(param).subscribe((res) => {
    if (res.result === 0 && res.content) {
      (window as any).stemplateConfig.weChatId = res.content.items.weChatId;
      (window as any).stemplateConfig.wxAuthUrl = res.content.items.wxAuthUrl;
    }
    (window as any).$sk.template.update({
      type: "common",
      data: {
        id: settings.tenantId,
        type: "tenantId",
        weChatId: (window as any).stemplateConfig.weChatId,
      },
    });
  });
  if ((window as any).$sk.template.isNotTemp) {
    cn();
  }
  preview();
  $cz.event("onInit");
}

export { onInit };
